import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import { useMemo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { memGetEntityList } from '@rexlabs/entity-normalizer';
import useModelActions from './use-model-actions';
import { argsChanged } from '../utils/queries';
import { merge } from 'lodash';
var counter = 0;
var consumerCounter = 0;
var empty = {};

function useEntityList(_ref) {
  var model = _ref.model,
      _ref$args = _ref.args,
      args = _ref$args === void 0 ? empty : _ref$args,
      propsUuid = _ref.uuid,
      _ref$fetch = _ref.fetch,
      fetch = _ref$fetch === void 0 ? true : _ref$fetch;
  var actions = useModelActions(model);
  var uuid = useMemo(function () {
    return propsUuid || ++counter;
  }, [propsUuid]);
  var consumerUuid = useMemo(function () {
    return "entityList".concat(++consumerCounter);
  }, []);
  var data = useSelector(function (state) {
    return model !== null && model !== void 0 && model.modelName ? memGetEntityList(state, model.modelName, uuid) : empty;
  }); // HACK: for whatever reason the args reference when using `query` changes here,
  // so until we fix that we're taking the comparibly small panilty of running
  // JSON.stringify of a small object on every render :/

  var memoArgs = _JSON$stringify(args);

  var needsToFetch = useMemo(function () {
    return fetch && argsChanged(data === null || data === void 0 ? void 0 : data.args, args);
  }, // eslint-disable-next-line
  [memoArgs, fetch, data === null || data === void 0 ? void 0 : data.args]); // HACK: on initial render, if we know that the `useEffect` will fetch, we want
  // to set the initial status to `loading`, even if the data is currently loaded
  // This might happen e.g. when the args are different

  var isFetching = useRef(needsToFetch);
  var isReallyFetching = isFetching.current;
  isFetching.current = false;
  useEffect(function () {
    if (!fetch) {
      return;
    }

    if (!(actions !== null && actions !== void 0 && actions.fetchList)) {
      return;
    }

    if (needsToFetch) {
      actions.fetchList({
        uuid: consumerUuid,
        id: uuid,
        args: args
      }).catch(function (e) {
        if (__DEV__) {
          console.error('Caught error in `useEntityList` initial load! This error will NOT ' + 'be forwarded, so if you want it to be thrown you will need to ' + 'either throw it manually in your API client or in your component ' + 'using `errors[x].originalError`.');
          console.error(e);
        }
      });
    } else {
      actions.registerListConsumer({
        id: uuid,
        uuid: consumerUuid
      });
    } // Unregister on unmount or when the id or args change


    return function () {
      return actions.unregisterConsumer({
        uuid: consumerUuid
      });
    };
  }, // eslint-disable-next-line
  [fetch, uuid, memoArgs]);
  var enhancedActions = useMemo(function () {
    return _objectSpread(_objectSpread({}, actions), {}, {
      fetchPage: function fetchPage() {
        var pageArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return actions.fetchPage(merge({}, {
          id: uuid,
          uuid: consumerUuid,
          args: args
        }, pageArgs));
      },
      refreshList: function refreshList() {
        var listArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return actions.refreshList(merge({}, {
          id: uuid,
          uuid: consumerUuid,
          args: args
        }, listArgs));
      }
    });
  }, [actions, uuid, args, consumerUuid]);
  return useMemo(function () {
    return {
      uuid: uuid,
      consumer: consumerUuid,
      actions: enhancedActions,
      status: isReallyFetching ? 'loading' : data !== null && data !== void 0 && data.status ? data === null || data === void 0 ? void 0 : data.status : fetch ? 'loading' : null,
      data: data === null || data === void 0 ? void 0 : data.items,
      pagination: data === null || data === void 0 ? void 0 : data.pagination,
      errors: data === null || data === void 0 ? void 0 : data.errors
    };
  }, [uuid, consumerUuid, enhancedActions, isReallyFetching, data]);
}

export default useEntityList;